import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'newsletters-list',
  templateUrl: './newsletters-list.component.html',
  styleUrls: ['./newsletters-list.component.scss'],
  animations: [slide]
})
export class NewslettersListComponent implements OnInit {
  newsletters:  FirebaseListObservable<any[]>;
  selectedNewsletter: any;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;

  constructor(
    private router: Router,
    private dbService: DBService
  ) {

    this.newsletters = this.dbService.getNewsletters();

  }


  ngOnInit() {
  }


  showNewsletter(key: string) {
    this.router.navigate([`/newsletters/${key}`]);
  }


  onAddClicked() {
    this.selectedNewsletter = null;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onEditClicked(newsletter, event) {
    event.stopPropagation();
    this.selectedNewsletter = newsletter;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeleteClicked(newsletter, event) {
    event.stopPropagation();
    this.showModalBg = true;
    this.showDeleteModal = true;
    this.selectedNewsletter = newsletter;
  }

  onConfirmDelete() {
    this.onHideDeleteModal();
    this.dbService.deleteNewsletter(this.selectedNewsletter.$key,
                                    this.selectedNewsletter.fileName);
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/newsletter/newsletters-list/newsletters-list.component.ts